<template>
  <f7-page name="asset-transfer">
    <f7-progressbar v-if="isLoading" color="green" infinite class="progressbar-top" key="1"></f7-progressbar>
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('Transfer') }}</f7-nav-title>
      <f7-nav-right>

        <label for="submit-asset-transfer" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>

    <form action="" @submit.prevent="onSubmit">
      <input type="submit" id="submit-asset-transfer" hidden >

      <!-- <f7-block-title>{{ $t('ServiceDetails') }}</f7-block-title>-->
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="IMEI"
            required
            validate
            validate-on-blur
            :label="$t('IMEI')"
            :placeholder="$t('IMEI')"
            class="disabled"
            v-model:value="IMEI"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Name"
            :label="$t('Name')"
            :placeholder="$t('Name')"
            v-model:value="Name"
            required
            validate
            class="disabled"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-assets text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Customer"
            :label="$t('Customer')"
            :placeholder="$t('Customer')"
            class="disabled"
            v-model:value="Customer"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <li class="item-input custom-smart-select-wrapper">
          <a ref="AutocompleteTransferTo" class="item-link item-content" href="#" id="autocomplete-standalone-ajax">
            <input type="hidden" :value="SelectedCustomerCode"/>
            <span class="item-media">
              <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
            </span>
            <div class="item-inner">
              <div class="item-title">{{ $t('TransferTo') }}</div>
              <div class="item-after">{{ SelectedUserName }}</div>
            </div>
          </a>
        </li>
      </f7-list>
    </form>
  </f7-page>
</template>

<script>
import {mapGetters} from "vuex";
import {QTAPI} from "../../services/qt-api";
import { f7 } from "framework7-vue";

export default {
  name: "asset-transfer",

  props: {
    f7router: Object,
    f7route: Object,

    assetData: Object,
  },

  data() {
    return {
      isLoading: false,

      Id: this.assetData.ID,
      IMEI: this.assetData.IMEI,
      Name: this.assetData.Name,
      Customer: this.assetData.Owner,
      AssetType: this.assetData.AssetType,
      MinSearchLength: 2,
      SelectedCustomerCode: null,
      SelectedUserName: null,
      autocompleteTransferTo: null,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfo'])
  },
  mounted() {
    let self = this

    this.SelectedCustomerCode = this.MajorToken
    this.SelectedUserName = `${ this.UserInfo.CustomerName } (${ this.UserInfo.Email })`

    this.autocompleteTransferTo = f7.autocomplete.create({
      openIn: 'page', //open in page
      openerEl: self.$refs.AutocompleteTransferTo, //link that opens autocomplete
      valueProperty: 'Code', //object's "value" property name
      textProperty: 'customDisplayName', //object's "text" property name
      closeOnSelect: true,
      autoFocus: true,
      limit: 50,
      preloader: true, //enable preloader
      searchbarPlaceholder: self.$t('EnterMinCharacters', {q: self.MinSearchLength}),
      source: async function (query, render) {
        let autocomplete = this;

        if (query.length < self.MinSearchLength) {
          return;
        }
        // Show Preloader
        autocomplete.preloaderShow();

        let data = {
          MajorToken: self.MajorToken,
          MinorToken: self.MinorToken,
          page: 1,
          rows: 20,
          sort: 'Name',
          order: 'asc',
          q: query,
        }
        let response = await QTAPI.GetCustomers(data)
        autocomplete.preloaderHide();
        if(!response || !response.rows){
          render([]);
          return
        }

        for (var i = 0; i < response.rows.length; i++) {
          response.rows[i].customDisplayName = `${ response.rows[i].Name } (${ response.rows[i].Email })`
        }

        render(response.rows);
      },
      on: {
        change: function (value) {
          var itemText = [],
              inputValue = [];
          for (var i = 0; i < value.length; i++) {
            itemText.push(value[i].customDisplayName);
            inputValue.push(value[i].Code);
          }
          self.SelectedCustomerCode = inputValue.join(', ')
          self.SelectedUserName = itemText.join(', ')
        },
      },
    });

  },
  beforeUnmount() {
    const self = this;
    // Destroy popup when page removed
    if (self.autocompleteTransferTo) self.autocompleteTransferTo.destroy();
  },

  methods: {
    async onSubmit(){
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,
        ids: this.Id,
        //IMEI: this.IMEI,
        //AssetType: this.AssetType,
        //Name: this.Name,
        CustomerCode: this.SelectedCustomerCode
      }
      this.isLoading = true;
      let response = await QTAPI.AssetTransfer(data)
      this.isLoading = false;
      if (!response){
        return
      }
      this.$store.commit('ASSET_UPDATED')
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('AssetTransferred', {name: this.Name}),
      }).open()
      this.f7router.back()
    }
  }
}
</script>

<style scoped>

</style>